import { AppDispatch, SpaceRequestActions, getDefaultSpace } from '@fullstory/redux';
import { getOrgId } from '@fullstory/redux/modules/fullstory/selectors';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Returns the space owner for the given object type and id.
 * @param objectId object id to search for
 * @param objectType the ObjectType to search for
 * @param enabled if the feature is enabled or not
 * @param shouldFetch whether the hook should dispatch an explicit ownership request
 * @returns Returns the owning space for an object. If enabled is false or if the
 *          object isn't found in our ownership reducer, this returns undefined.
 */
export const useDefaultSpace = (enabled = false) => {
  const orgId = useSelector(getOrgId);
  const dispatch = useDispatch<AppDispatch>();
  const defaultSpace = useSelector(getDefaultSpace);

  const fetch = useCallback(() => {
    dispatch(SpaceRequestActions.getDefaultSpace({ orgId }));
  }, [dispatch, orgId]);

  useEffect(() => {
    if (enabled) {
      fetch();
    }
  }, [fetch, enabled]);

  return defaultSpace;
};
